<template>
  <div v-if="text">
    <b-dropdown-item class="drop-item" 
        :to="route"
      >
        <img
          class="dropItem"
          :src="require(`@/assets/${image}`)"
          :alt="`${altTxt}`"
        />
        {{text}}
      </b-dropdown-item>
  </div>
</template>

<script>
export default {
  name: "DropDownItem.vue",
  props: ["image", "route", "text", "altTxt", "showItem"],
  data() {
    return {
    }
  },
}
</script>

<style scoped>

img.dropItem {
  max-height: 25px;
  max-width: 25px;
  border-radius: 5px;
  margin-right: 10px;
}

</style>